export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const contacts = state => state.contacts
export const addresses = state => state.addresses
export const position = state => state.position
